import Core             from '@/core/Core';
import FeedsDAO          from '@/core/services/Feeds/FeedsDAO';
import FeedRecord        from '@/core/services/Feeds/FeedRecord';
import type EntityPointer from '@/domains/EntityPointer/EntityPointer';
import type TimeStamp     from '@/core/types/TimeStamp';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';

/**
 * Сервис фидов.
 *
 * Только чтение: записи в фид добавляет бэк внутри доменных операций
 * (создание комментария, событие лога) — отдельного RPC на добавление нет,
 * поэтому на фронте нет add*. Комментарий создаётся через CommentsService,
 * фид подхватит его при следующей загрузке.
 *
 * Порядок записей задаёт бэк (новые внизу) — на фронте не пересортировываем.
 */
class FeedsService {

	/**
	 * Загрузить фид для одной или нескольких родительских сущностей.
	 *
	 * @param parentEntity один указатель либо массив — несколько родителей
	 *                     в одном запросе (бывший каскад extraParentEntities).
	 * @param feedTypes    фильтр по типам записей: 'comment' | 'changelog' | 'notification'.
	 * @param timeFrom     загрузить записи начиная с момента (для дозагрузки).
	 * @param isPublic     флаг для получения публичного фида. в случае тендера вернётся маскированная версия фида
	 */
	static async getPaginated(
		parentEntity: EntityPointer | EntityPointer[],
		feedTypes?: string[],
		timeFrom?: TimeStamp,
    isPublic?: boolean,
		pagination?: RpcDataPagination,
	): Promise<{ data: FeedRecord[]; pagination: RpcDataPagination | null }> {
		const response = await FeedsDAO.get(parentEntity, feedTypes, timeFrom, isPublic, pagination);

		return {
			data:       Core.utils.hydrateArray(response.data, FeedRecord.fromServer),
			pagination: response.meta.pagination,
		};
	}

}

export default FeedsService;
